import React from 'react';
import Input from '../../../../../../components/Input/Input';
import './DetailtService.css';
import { useLocation } from 'react-router-dom';

const DetailtService = () => {
  const { service } = useLocation().state;

  return (
    <div className="detail-service-page">
      <div className="detail-service-container">
        <div className="title-container">
          <h1 className="page-title">
            <span className="highlight">Consult</span> History of Services Received
          </h1>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Request Folio</label>
            <Input
              type="text"
              value={service?.id || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <Input
              type="text"
              value={service?.category || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Subcategory</label>
            <Input
              type="text"
              value={service?.subcategory || ''}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Supplier</label>
            <Input
              type="text"
              value={service?.supplier || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Type of service</label>
            <Input
              type="text"
              value={service?.typeOfService || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Date</label>
            <Input
              type="text"
              value={service?.date || ''}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Time</label>
            <Input
              type="text"
              value={service?.time || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Number of barter bucks used</label>
            <Input
              type="text"
              value={service?.tokensUsed || ''}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Status</label>
            <Input
              type="text"
              value={service?.status || ''}
              disabled={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailtService;